import React, { Fragment, useState } from "react";
import styled from "styled-components";
import { Button } from "../../../components";
import { _O } from "../../../modules/utils";
import { checkNum10 } from "../../../modules/utils/CheckLogic";
import { IC } from "../../../resources/Assets";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import { CheckIcon, Checkbox } from "../Modal/ModalStyle";
import { BackgroundDiv, HeaderTitle, NoticeText } from "./ReceiptStyle";
import useTitle from "../../../modules/hooks/useTitle";

const NftfNotice = props => {
  const [toggle, setToggle] = useState(false);
  useTitle("진료예약_비대면_진료대상안내");

  const noMoreToday = () => {
    localStorage.setItem(
      "nftfNotice",
      JSON.stringify({
        check: toggle,
        date:
          new Date().getFullYear() +
          checkNum10(new Date().getMonth() + 1) +
          checkNum10(new Date().getDate()),
      })
    );
  };

  const nextBtnEvent = () => {
    noMoreToday();
    _O.Open("/nftf/guide");
  };

  return (
    <Fragment>
      <ScrollToTop />
      <BackgroundDiv>
        <HeaderTitle>
          <div
            style={{ width: "40px", height: "40px" }}
            onClick={() => {
              _O.Open(sessionStorage.getItem("backUrl"));
            }}>
            <img src={IC.etc.ICON_CHEVRON_LEFT} />
          </div>
          <div>비대면 진료 대상 안내</div>
          <div style={{ width: "40px", height: "40px" }}>
            {/* <img src={ArrowLeft} /> */}
          </div>
        </HeaderTitle>

        <Body>
          <NoticeText>
            누구나 비대면 진료를 <br /> 받으실 수 있어요
          </NoticeText>

          <Content>
            <div>
              <img src={IC.etc.ICON_NFTF_NOTICE} style={{ width: "100%" }} />
            </div>

            <ContentTitle>
              2024년 2월 23일 부터 정부정책 변경에 따라 <br /> 제한없는 비대면
              진료를 사용할 수 있어요.
            </ContentTitle>

            <ContentBody>
              기존의 초진, 재진에 대한 제한이 사라지고 제한없는 비대면 진료가
              가능해졌습니다. 감기나 몸살처럼 경증 환자나, 지속관리가 필요한
              만성질환 환자분들도 비대면진료 초진이 가능합니다. 제한 없는 비대면
              진료 종료 시점은 추후 별도로 공지할 예정입니다.
            </ContentBody>
          </Content>
        </Body>

        <div
          style={{
            position: "absolute",
            width: "calc(100% - 40px)",
            padding: "24px 20px",
            bottom: "0px",
            display: "flex",
            gap: "24px",
            flexFlow: "column",
            background:
              "linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.7) 79%, #fff 58%)",
          }}>
          <CheckBoxArea>
            <Checkbox>
              <CheckIcon type="checkbox" onClick={() => setToggle(!toggle)} />
              <span>오늘 하루 더이상 보지 않기</span>
            </Checkbox>
          </CheckBoxArea>
          <Button
            severity="primary"
            disable="off"
            clickEvent={() => nextBtnEvent()}>
            다음
          </Button>
        </div>
      </BackgroundDiv>
    </Fragment>
  );
};

const Body = styled.div`
  align-self: stretch;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 40px;
  padding: 40px 20px;
`;

const Contents = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  padding: 40px 20px;
`;

const Content = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 0;
`;

const ContentTitle = styled.span`
  align-self: stretch;
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: left;
  color: #333;
`;

const ContentBody = styled.span`
  /* width: 313px; */
  height: 110px;
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #888;
`;

const CheckBoxArea = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  /* padding: 0 20px; */
  border-radius: 6px;
`;

export default NftfNotice;
